import React, { useState } from 'react';
import SharedButton from './SharedButton';

const periodicityLabels = {
  once:       'Única vez',
  weekly:     'Semanal',
  monthly:    'Mensual',
  semiannual: 'Semestral',
};

// FIX: parsear fecha local para evitar el bug del día anterior
const parseLocalDate = dateStr => {
  if (!dateStr) return new Date();
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d);
};

const occursOn = (event, day) => {
  const evDate = parseLocalDate(event.date);
  switch (event.periodicity) {
    case 'once':
      return evDate.toDateString() === day.toDateString();
    case 'weekly':
      return evDate.getDay() === day.getDay();
    case 'monthly':
      return evDate.getDate() === day.getDate();
    case 'semiannual': {
      const monthDiff =
        (day.getFullYear() - evDate.getFullYear()) * 12 +
        (day.getMonth() - evDate.getMonth());
      return evDate.getDate() === day.getDate() && monthDiff >= 0 && monthDiff % 6 === 0;
    }
    default:
      return false;
  }
};

const CalendarWeeklyView = ({ events, onEdit, onDelete, onSelectEvent }) => {
  const [currentWeekStart, setCurrentWeekStart] = useState(new Date());
  const today = new Date();

  const getWeekDays = date => {
    const d0  = new Date(date);
    const dow = d0.getDay() || 7;
    d0.setDate(d0.getDate() + 1 - dow); // mueve a lunes
    return Array.from({ length: 7 }).map((_, i) => {
      const d = new Date(d0);
      d.setDate(d0.getDate() + i);
      return d;
    });
  };

  const weekDays = getWeekDays(currentWeekStart);

  const shiftWeek = n => {
    const d = new Date(currentWeekStart);
    d.setDate(d.getDate() + 7 * n);
    setCurrentWeekStart(d);
  };

  const getEventsForDay = day =>
    events
      .filter(ev => occursOn(ev, day))
      .sort((a, b) => a.time.localeCompare(b.time));

  const dayNames = ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'];

  return (
    <div className="mb-6">
      <div className="flex justify-between items-center mb-4">
        <button
          onClick={() => shiftWeek(-1)}
          className="px-3 py-1.5 text-sm font-semibold bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
        >
          ‹ Anterior
        </button>
        <span className="text-sm font-semibold text-gray-700">
          {weekDays[0].toLocaleDateString('es-MX', { day: 'numeric', month: 'short' })} –{' '}
          {weekDays[6].toLocaleDateString('es-MX', { day: 'numeric', month: 'short', year: 'numeric' })}
        </span>
        <button
          onClick={() => shiftWeek(1)}
          className="px-3 py-1.5 text-sm font-semibold bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
        >
          Siguiente ›
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-7 gap-2">
        {weekDays.map(day => {
          const isToday   = day.toDateString() === today.toDateString();
          const dayEvents = getEventsForDay(day);
          return (
            <div
              key={day.toISOString()}
              className={`rounded-xl p-2 min-h-[120px] ${
                isToday ? 'bg-[#961914] text-white' : 'bg-gray-50 border border-gray-200'
              }`}
            >
              <h5 className={`font-bold text-center text-xs mb-2 ${isToday ? 'text-white' : 'text-gray-700'}`}>
                {dayNames[day.getDay()]} {day.getDate()}
              </h5>

              {dayEvents.length === 0 ? (
                <p className={`text-xs text-center ${isToday ? 'text-red-200' : 'text-gray-400'}`}>—</p>
              ) : (
                dayEvents.map(ev => {
                  const isSchedule = ev.type === 'schedule';
                  return (
                    <div
                      key={ev.id + '_' + day.toDateString()}
                      onClick={() => onSelectEvent(ev)}
                      className={`mb-1.5 p-1.5 rounded-lg cursor-pointer text-xs shadow-sm ${
                        isSchedule
                          ? 'bg-blue-100 text-blue-800 border border-blue-200'
                          : 'bg-white text-gray-800 border border-gray-100 hover:border-[#961914]/30'
                      }`}
                    >
                      <p className="font-semibold truncate">{ev.time} {ev.subdiscipline}</p>
                      <p className="text-gray-500 truncate">{ev.teacher}</p>
                      <p className="text-gray-400">{ev.level}</p>
                      {!isSchedule && (
                        <div
                          className="flex gap-1 mt-1"
                          onClick={e => e.stopPropagation()}
                        >
                          <button
                            onClick={() => onEdit(ev)}
                            className="flex-1 py-0.5 text-[10px] font-semibold bg-blue-50 text-blue-700 rounded hover:bg-blue-100"
                          >
                            Editar
                          </button>
                          <button
                            onClick={() => onDelete(ev.id)}
                            className="flex-1 py-0.5 text-[10px] font-semibold bg-red-50 text-red-700 rounded hover:bg-red-100"
                          >
                            Borrar
                          </button>
                        </div>
                      )}
                    </div>
                  );
                })
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CalendarWeeklyView;